import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBoxProps {
  defaultValue?: string;
  placeholder?: string;
  size?: "md" | "lg";
  className?: string;
}

export default function SearchBox({
  defaultValue = "",
  placeholder = "搜索影片名称、类型或地区…",
  size = "md",
  className = "",
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  };

  const isLg = size === "lg";

  return (
    <form
      onSubmit={submit}
      className={`flex items-center w-full bg-background-900 border border-background-700 rounded-full focus-within:border-primary-500 transition-colors ${
        isLg ? "px-4 py-2.5" : "px-3 py-1.5"
      } ${className}`}
    >
      <span
        className={`flex items-center justify-center text-foreground-400 ${
          isLg ? "w-6 h-6 text-xl" : "w-5 h-5 text-base"
        }`}
      >
        <i className="ri-search-line"></i>
      </span>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className={`flex-1 bg-transparent text-foreground-100 placeholder:text-foreground-500 outline-none px-3 ${
          isLg ? "text-base" : "text-sm"
        }`}
      />
      <button
        type="submit"
        className={`shrink-0 rounded-full bg-primary-600 hover:bg-primary-500 text-background-50 font-medium whitespace-nowrap cursor-pointer transition-colors ${
          isLg ? "px-6 py-2 text-sm" : "px-4 py-1.5 text-xs"
        }`}
      >
        搜索
      </button>
    </form>
  );
}